import { render, staticRenderFns } from "./memberLoss.vue?vue&type=template&id=066a6848&scoped=true&"
import script from "./memberLoss.vue?vue&type=script&lang=js&"
export * from "./memberLoss.vue?vue&type=script&lang=js&"
import style0 from "./memberLoss.vue?vue&type=style&index=0&id=066a6848&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066a6848",
  null
  
)

export default component.exports